import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { APP_ROUTES } from '../contants/APP_ROUTES';
import { AUTH } from '../contants/AUTH';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthGuardService {

	constructor(
		private _router: Router,
		private _authenticationService: AuthenticationService
	) 
		{ }

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (!this._authenticationService.isTokenExpired()) {
			return true;
		}

		// not logged in so redirect to login page with the return url
		this._router.navigate([`${APP_ROUTES.login}`], { queryParams: { 'returnUrl': state.url } });
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard.service.ts